// @ts-nocheck
import store, { subscribe } from 'shared/store'
import { actionNames } from 'shared/store/ducks/userSession'
import { HIDE_MODAL } from 'shared/store/ducks/events'
import Storage from 'views/assets/scripts/services/storage/storage'

import { LOGIN_FORM_SUBMITTED } from 'shared/consts'
import { SHOW_ABO_MODAL_ID } from 'views/consts'
import blockUI from 'views/assets/scripts/blockUI'
import runClientSideScriptForSubscription, {
  getSubscriptionElements,
  showLoginFormWithErrorMessage,
  showLoginForm,
  getProductIDForProductListing
} from 'views/assets/scripts/subscription'

import { PAGE_TYPE_CONFIRMATION, PAGE_TYPE_PRODUCT } from 'shared/consts/page'

import MountPointsClass from 'shared/utils/mountPoints'

const storage = new Storage('sessionStorage')
const isStorageAvailable = storage.isAvailable()

const {
  rootElement,
  createSubscriptionLink,
  createSubscriptionLinkModal
} = getSubscriptionElements()

// eslint-disable-next-line complexity
const mountSubscriptionToDOM = async (userSession, mountPointsInstance) => {
  // @ts-ignore
  const {
    isLoggedIn,
    user: { customerNumber: id = undefined } = {}
  } = userSession

  let {
    pageProperties: { productId }
  } = store.getPublicRuntimeConfig()

  const {
    pageProperties: { pageType }
  } = store.getPublicRuntimeConfig()

  // @ts-ignore
  window.shopCustomerId = id

  const containsHash = urlHash => window.location.hash.includes(urlHash)
  // login form in modal
  // it's shown when you click subscription link
  const isLoginFormSubmitted = containsHash(LOGIN_FORM_SUBMITTED)
  const showLoginOrAboModal = containsHash(SHOW_ABO_MODAL_ID)
  const showSubscriptionModalOnPageLoad = storage.get(
    'showSubscriptionModalOnPageLoad'
  )
  const isEligibleProductForSubscription = isLoggedIn && createSubscriptionLink
  const isLoginFormSubmittedForEligibleProduct =
    isEligibleProductForSubscription &&
    (showLoginOrAboModal ||
      (showSubscriptionModalOnPageLoad && isLoginFormSubmitted))

  const showLoggedInFormOnPageLoad = !isLoggedIn && showLoginOrAboModal
  const showLoggedInFormHasErrorsOnPageLoad =
    !isLoggedIn && isLoginFormSubmitted
  if (isEligibleProductForSubscription) {
    // load once the subscription client script
    createSubscriptionLink.forEach(link => {
      link.addEventListener('click', async () => {
        const unblockUI = blockUI()
        try {
          const subscriptionClientContainer = await import(
            /* webpackChunkName: "SubscriptionClientContainerWithRender" */
            './index'
          )

          if (isStorageAvailable) {
            storage.set('showSubscriptionModalOnPageLoad', false)
          }

          if (pageType === PAGE_TYPE_CONFIRMATION) {
            productId = getProductIDForProductListing(link)
          }

          subscriptionClientContainer.default({
            container: rootElement,
            productId,
            mode: 'CREATE_OR_EDIT_SUBSCRIPTION',
            onSuccess: response => {
              const { shippingAddressId = null } = response
              window.location.href = mountPointsInstance.getAccountSubscriptions(
                {
                  shippingId: shippingAddressId,
                  subscriptionAction: 'subscriptionCreated'
                }
              )
            }
          })
        } catch (err) {
          throw new Error(err)
        } finally {
          unblockUI()
        }
      })
    })
  }

  if (isLoginFormSubmittedForEligibleProduct) {
    createSubscriptionLinkModal.click()
  }

  if (showLoggedInFormOnPageLoad) {
    showLoginForm()
  }

  if (showLoggedInFormHasErrorsOnPageLoad) {
    showLoginFormWithErrorMessage()
  }
}

export default () => {
  if (!createSubscriptionLinkModal) {
    return
  }

  subscribe.after.once(actionNames.setUserSession, ({ userSession }) => {
    const {
      publicConfig: {
        subscriptionServiceAPIURL: subscriptionApiUrl,
        mountPoints,
        tenant,
        language
      },
      pageProperties: { pageType, coreShopEnvironment }
    } = store.getPublicRuntimeConfig()

    const { isLoggedIn } = userSession

    const { buyboxSubscriptionLink } = getSubscriptionElements()

    if (subscriptionApiUrl) {
      // @ts-ignore
      window.Red = {
        SETTINGS: {
          subscriptionApiUrl
        }
      }
    }

    const mountPointsInstance = new MountPointsClass({
      mountPoints,
      tenant,
      language,
      coreShopEnvironment
    })

    if (!isLoggedIn && buyboxSubscriptionLink) {
      buyboxSubscriptionLink.addEventListener('click', () => {
        if (isStorageAvailable) {
          storage.set('showSubscriptionModalOnPageLoad', true)
        } else {
          // fallback for browsers which don't support session storage
          window.location.href = mountPointsInstance.getLogin()
        }
      })

      subscribe.after(HIDE_MODAL, () => {
        if (isStorageAvailable) {
          storage.set('showSubscriptionModalOnPageLoad', false)
        }
      })
    }

    if (pageType === PAGE_TYPE_PRODUCT || pageType === PAGE_TYPE_CONFIRMATION) {
      mountSubscriptionToDOM(userSession, mountPointsInstance)
      runClientSideScriptForSubscription(userSession)
    } else {
      createSubscriptionLinkModal.addEventListener('click', () => {
        const state = store.getState()
        const {
          events: { productUrl }
        } = state

        window.location.href = `${productUrl}#${SHOW_ABO_MODAL_ID}`
      })
    }
  })
}
